import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Hide } from '../Hide'
import i18n from '../../../config/i18n'
import './Description.css'

const Description = ({
    split = false,
    html = { __html: '' },
    dark = false,
    isUkraineInfo = false
}) => {
    const [isUkraineDocumentsTrimed, setIsUkraineDocumentsTrimed] = useState(true)
    const [ukraineDocuments, setUkraineDocuments] = useState([])
    const className = split ? 'split' : ''
    const fontColor = dark ? 'dark' : ''

    useEffect(() => {
        if (isUkraineInfo) {
            const documents = html.__html.split('</p>')
            setUkraineDocuments(documents)
        }
    }, [])

    const recalculateInnerHtml = () => {
        if (isUkraineInfo && isUkraineDocumentsTrimed) {
            let output = { __html: '' }
            const documents = html.__html.split('</p>')
            for (let i = 0; i < 6; i++) {
                output.__html += ukraineDocuments[i]
            }
            return output
        } else {
            return html
        }
    }
    return (
        <Hide ifEmpty={html.__html}>
            <div
                className={`description description--${className} description--${fontColor}`}
                dangerouslySetInnerHTML={recalculateInnerHtml()}
            />
            {isUkraineDocumentsTrimed && ukraineDocuments.length > 7 && (
                <div className="ukraine-loadmore-btn-wrapper">
                    <div
                        className="ukraine-loadmore-btn"
                        onClick={() => setIsUkraineDocumentsTrimed(false)}
                    >
                        {i18n.t('ukraineForm.showAllDocuments')}
                    </div>
                </div>
            )}
        </Hide>
    )
}

Description.propTypes = {
    split: PropTypes.bool,
    html: PropTypes.shape({
        __html: PropTypes.string
    }),
    dark: PropTypes.bool
}

export { Description }
